import update from 'immutability-helper';
import { flattenDeep } from 'lodash';
import { clone } from 'common/utils/generic';
import { EQUAL } from 'common/constants/modifiers';
import { ANY, NIL } from 'common/constants/constants';
import { areFiltersEqual } from 'common/utils/filters';
import { Filter, Comparator, Genre, Attribute, AdvancedOptions, DefaultAdvancedOptions } from 'common/constants/types';

export const handleFilterSelect = (
  value: string,
  filterIndex: number,
  modalFilters: Filter[],
  comparator: Comparator = '=',
  advancedOptions: AdvancedOptions = DefaultAdvancedOptions
) => {
  const updatedModalFilters = clone(modalFilters);
  updatedModalFilters[filterIndex] = {
    ...modalFilters[filterIndex],
    // currently API only supports single value, but in future
    // we can change to multiselect, in which value will be an array
    filteredValues: value,
    comparator,
    advancedOptions,
  };
  return updatedModalFilters;
};

export const flattenAttributes = (values: { genres: Genre[] }) => {
  const flattenedMap = values.genres.map(genre =>
    genre.sections.map(section => section.attribute_types.map(attributeType => attributeType))
  );
  return flattenDeep(flattenedMap);
};

export const handleApplyFilters = (modalFilters: Filter[]) => {
  const nonEmptyFilters = modalFilters.filter(filter =>
    filter.filteredValues && filter.filteredValues.toString().length > 0
  );

  // Remove duplicate filters
  return nonEmptyFilters.filter((nonEmptyFilter, index) =>
    nonEmptyFilters.findIndex(filter => areFiltersEqual(filter, nonEmptyFilter)) === index
  );
};

export const onAttributeChange = (
  attributeApiData: { genres: Genre[] },
  modalFilters: Filter[],
  genreSelected: string,
  sectionSelected: string,
  attributeTypeSelected: string,
  attributeSelected: string
) => {
  const attributeType = attributeApiData.genres
    .find(genre => genre.name === genreSelected)?.sections
    .find(section => section.name === sectionSelected)?.attribute_types
    .find(type => type.name === attributeTypeSelected);
  if (!attributeType) throw new Error(`Could not find attribute type ${attributeTypeSelected}`);
  const filter: Filter = {
    ...attributeType,
    attributes: attributeType?.listable
      ? (attributeType.attributes as Pick<Attribute, 'value'>[]).concat([{ value: ANY }, { value: NIL }])
      : [{ value: ANY }, { value: NIL }],
    comparator: EQUAL,
    advancedOptions: DefaultAdvancedOptions,
    filteredValues: attributeSelected,
  };
  return update(modalFilters, {
    $push: [filter],
  });
};
